import { IPaged, IQueryParams, IUser } from '@ipnote/interface';
import { createActionGroup, props } from '@ngrx/store';
import { UserRole } from '@ipnote/enum';

export interface StaffUpsertPayload {
  email: string;
  password?: string;
  name: string;
  secondName?: string;
  patronymic?: string;
  role: UserRole;
}

export const staffActions = createActionGroup({
  source: 'Company Staff',
  events: {
    'load staff': props<{ queryParams: IQueryParams }>(),
    'load staff success': props<{ staff: IPaged<IUser> }>(),
    'load staff failure': props<{ error: string }>(),

    'create staff member': props<{ dto: StaffUpsertPayload }>(),
    'create staff member success': props<{ user: IUser; plainPassword: string }>(),
    'create staff member failure': props<{ error: string }>(),

    'update staff member': props<{ id: number; dto: Partial<StaffUpsertPayload> }>(),
    'update staff member success': props<{ user: IUser }>(),
    'update staff member failure': props<{ error: string }>(),

    'delete staff member': props<{ id: number }>(),
    'delete staff member success': props<{ id: number }>(),
    'delete staff member failure': props<{ error: string }>(),
  },
});
